"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOLBAR_I18N_PREFIX = exports.controlPropType = exports.ToolbarControlMargins = exports.MenuTypes = exports.ToolbarControlTypes = void 0;

var _react = require("react");

var ToolbarControlTypes = {
  BUTTON: 'BUTTON',
  SELECT: 'SELECT',
  DIVIDER: 'DIVIDER',
  MORE_MENU: 'MORE_MENU',
  ADVANCED_MENU: 'ADVANCED_MENU',
  INSERT_MENU: 'INSERT_MENU'
};
exports.ToolbarControlTypes = ToolbarControlTypes;
var MenuTypes = [ToolbarControlTypes.ADVANCED_MENU, ToolbarControlTypes.INSERT_MENU, ToolbarControlTypes.MORE_MENU];
exports.MenuTypes = MenuTypes;
var ToolbarControlMargins = {
  DEFAULT: 8,
  BUTTON: 2,
  ZERO: 0
};
exports.ToolbarControlMargins = ToolbarControlMargins;

var controlPropType = _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(Object.keys(ToolbarControlTypes)).isRequired,
  control: _react.PropTypes.string
});

exports.controlPropType = controlPropType;
var TOOLBAR_I18N_PREFIX = 'RichTextLib.toolbar';
exports.TOOLBAR_I18N_PREFIX = TOOLBAR_I18N_PREFIX;